import React from 'react';
import moment from "moment";
import StockChart from "./stockChart/StockChart";
import store from "../../store";
import { countsTotals } from "../../providers/charts";
import { arrangeCompanyName } from "../../lib/utils";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import NoChartData from "../common/NoChartData";
import Loader from "../common/Loader";
import HotSpot from "../common/HotSpot";
import Tooltip from "../common/Tooltip";

const Translate = require('react-redux-i18n').Translate;
const I18n = require('react-redux-i18n').I18n;

const stateMap = (store) => ({
    i18n: store.i18n,
    chartReducer: store.chartReducer,
    userReducer: store.userReducer
});

class TotalTransactionsChart extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        // Initialize all checkboxes as controlled
        const initialCheckboxes = {};
        props.afms.forEach(afmObj => {
            initialCheckboxes[afmObj.afm] = props.afm.includes(afmObj.afm);
        });

        this.state = {
            afm: props.afm,
            mid: props.mid,
            countsTotalsData: null,
            transactionsMode: false,
            dateFrom: moment(moment().subtract(1, 'day')).subtract(12, 'months').format('YYYY-MM-DD'),
            dateTo: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            ...initialCheckboxes
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchCountsTotals();
    }

    componentDidUpdate(prevProps) {
        if (this.props.afm !== prevProps.afm || this.props.mid !== prevProps.mid) {
            this.setState(
                { afm: this.props.afm, mid: this.props.mid },
                () => {
                    this.fetchCountsTotals();
                    this.arrangeCheckedAfms(this.state.afm);
                }
            );
        }

        if (this.props.i18n.locale !== prevProps.i18n.locale) {
            this.fetchCountsTotals();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchCountsTotals = () => {
        const { afm, mid, dateFrom, dateTo } = this.state;
        const data = { afm, mid, dateFrom, dateTo };

        store.dispatch(countsTotals(data)).then((response) => {
            if (this._isMounted) {
                this.setState({ countsTotalsData: response.value.data });
            }
        });
    }

    transactionsModeCheck = () => {
        this.setState(prevState => ({ transactionsMode: !prevState.transactionsMode }));
    }

    handleCheck = (event) => {
        const afm = event.target.id;
        const checked = event.target.checked;

        this.setState(prevState => ({
            [afm]: checked,
            afm: this.arrangeAfmsArr(afm, checked, prevState.afm)
        }), () => this.fetchCountsTotals());
    }

    arrangeCheckedAfms = (arr) => {
        const allAfms = this.props.afms;
        const afmsArr = arr.includes(',') ? arr.split(',') : [arr];

        const newCheckboxStates = {};
        allAfms.forEach(afmObj => {
            newCheckboxStates[afmObj.afm] = afmsArr.includes(afmObj.afm);
        });

        this.setState(newCheckboxStates);
    }

    arrangeAfmsArr = (afm, checked, prevArr) => {
        let afmsArr = prevArr.includes(',') ? prevArr.split(',') : [prevArr];
        if (checked && !afmsArr.includes(afm)) {
            afmsArr.push(afm);
        } else if (!checked && afmsArr.includes(afm)) {
            afmsArr.splice(afmsArr.indexOf(afm), 1);
        }
        return afmsArr.toString();
    }

    render() {
        const { afms, userReducer, chartReducer, i18n } = this.props;
        const { countsTotalsData, transactionsMode, afm: selectedAfms } = this.state;

        const isSingleAfm = userReducer.getAssociationsResponse.merchantType !== "multiAfm";

        return (
            <React.Fragment>
                <h4 className="reports__transactions--section_title">
                    <Translate value="pages.reports.titles.transactions"/>
                    <span>
                        <Tooltip
                            placement="right"
                            tooltipButtonId="reportsTransactionsChart"
                            tooltipLabelClass="reports-transactions-chart-label"
                            popoverId="reports-transactions-chart-tltp"
                            tooltipText='tooltipTrancactionsChart'
                        />
                    </span>
                </h4>

                {userReducer.showHotSpots && (
                    <div className="hotSpot-element__wrapper">
                        <HotSpot hotProp="exportChartHints" placement="bottom"/>
                    </div>
                )}

                <div className={`reports__transactions--chart col-sm-12 col-xs-12 ${isSingleAfm ? "col-md-12" : "col-md-9"}`}>
                    {countsTotalsData && countsTotalsData.length > 0 && chartReducer.totalTransactions.fetched ? (
                        <>
                            <StockChart
                                key="overview-stock-chart"
                                data={countsTotalsData}
                                column={transactionsMode ? 'count' : 'amount'}
                                panelType={transactionsMode ? 'line' : 'step'}
                                id={'TotalsTransactions'}
                                filename={I18n.t("pages.reports.titles.transactions")}
                                dates={{ dateFrom: this.state.dateFrom, dateTo: this.state.dateTo }}
                            />
                            <div className="reports__chart-switch chart-left reports__chart-switch--blue-purple">
                                <div className={`amount-label report-translate${!transactionsMode ? "_active" : ""}`}>
                                    <Translate value="pages.reports.amountTitle"/>
                                </div>
                                <input
                                    type="checkbox"
                                    className="cbx"
                                    id='transactionsMode'
                                    checked={transactionsMode}
                                    onChange={this.transactionsModeCheck}
                                />
                                <label htmlFor="transactionsMode" className="toggle"><span/></label>
                                <div className={`count-label report-translate${transactionsMode ? "_active" : ""}`}>
                                    <Translate value="pages.reports.countTitle"/>
                                </div>
                            </div>
                        </>
                    ) : !chartReducer.totalTransactions.fetching ? (
                        <NoChartData hasAfms={!selectedAfms}/>
                    ) : null}

                    {chartReducer.totalTransactions && chartReducer.totalTransactions.fetching && (
                        <Loader
                            bouncing={false}
                            color={'midnight-blue'}
                            loaderStyles={{ minHeight: "112.5px", margin: "40px 0" }}
                            message="loader.generic"
                        />
                    )}

                    {userReducer.showHotSpots && (
                        <div className="hotSpot-element__wrapper">
                            <HotSpot hotProp="reportsTransactions" image="reportsTransactions" placement="bottom"/>
                        </div>
                    )}
                </div>

                <div
                    className="reports__transactions--companies_selection col-md-3 col-sm-12 col-xs-12"
                    style={{ display: isSingleAfm ? "none" : "" }}
                >
                    <div className="reports__transactions--company_cbox--header">
                        <Translate value="pages.reports.checkboxesHeader"/>
                    </div>
                    {afms.map(afmEl => (
                        <div key={`company_cbox--${afmEl.afm}`} className="reports__transactions--company_cbox">
                            <input
                                type="checkbox"
                                id={afmEl.afm}
                                checked={!!this.state[afmEl.afm]}  // Ensures controlled input
                                onChange={this.handleCheck}
                            />
                            <label htmlFor={afmEl.afm}>
                                <span>{arrangeCompanyName(afmEl, i18n.locale)}</span>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(connect(stateMap)(TotalTransactionsChart));
